/**
 * منطقِ خالصِ «مسدود کردن» — آنچه هر دو رابط بعد از بلاک باید یکسان بدانند.
 *
 * ═══ چه بود ═══
 *
 * تا WHOSUP-262 این فایل شکلِ «گروه‌های مشترک» را می‌ساخت: `block_user`
 * (0146) فهرستِ گروه‌هایی را برمی‌گرداند که هر دو در آن بودند، و رابط قدمِ
 * دومی داشت — «در این‌ها هم از هم جدا شوید؟».
 *
 * ═══ چرا رفت ═══
 *
 * گروه در این اپ یک چیزِ شخصی است، فهرستِ خودِ سازنده‌اش. بلاک‌کننده
 * **نباید بفهمد** طرفِ مقابل چه گروه‌هایی دارد — و همان فهرست دقیقاً همین را
 * لو می‌داد. حالا `block_user` (0154) خودش بی‌صدا هر کدام را از گروه‌های
 * دیگری برمی‌دارد و هیچ فهرستی برنمی‌گرداند؛ چیزی برای چیدن نمانده.
 *
 * ═══ چه ماند ═══
 *
 * فقط این: کدام کوئری‌ها بعد از بلاک (و بعد از رفعش) دیگر حقیقت نمی‌گویند.
 * یک جا، چون شیتِ موبایل و مودالِ وب هر دو باید همین‌ها را تازه کنند — اگر
 * هر کدام فهرستِ خودش را داشته باشد، اولین تغییر در یکی می‌افتد و کسی نمی‌فهمد.
 */

/**
 * کلیدهای react-query که بلاک کهنه‌شان می‌کند.
 *
 *   • `friends`, `contacts` — فهرستِ دوستان و پیشنهادها فوراً باید او را از
 *     دست بدهند (خواسته‌ی صریحِ WHOSUP-230).
 *   • `groups` — `block_user` او را از گروه‌های من برداشته؛ عددِ کنارِ گروه
 *     و فهرستِ اعضا باید همین را نشان بدهند.
 *   • `blockedUsers` — صفحه‌ی «کاربرانِ مسدودشده».
 *   • `incoming`, `signal`, `messages` — از مایگریشن 0160 (WHOSUP-309)
 *     سیگنال‌ها و پیام‌های چتِ او از دیدِ من پنهان‌اند؛ اپل چک می‌کند که
 *     «بلافاصله» باشد، پس کشِ قدیمی نباید تا رفرشِ بعدی نشانشان بدهد.
 */
export const BLOCK_STALE_QUERIES: readonly (readonly string[])[] = [
  ['friends'], ['groups'], ['contacts'], ['blockedUsers'],
  ['incoming'], ['signal'], ['messages'],
];
